import type { InboxWorkflowSelectOption } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import type { LetterDeliveryMode } from "../../../contract"

export type { LetterDeliveryMode } from "../../../contract"

export type LetterDeliveryModeOption = InboxWorkflowSelectOption & {
  value: LetterDeliveryMode
  selectable?: boolean
}

export type LetterDeliveryModeAccessOptions = {
  automaticLetterDeliveryAllowed?: boolean
  automaticLetterDeliveryDisabledReason?: string | null
}

const manualDeliveryOption: LetterDeliveryModeOption = {
  value: "manual",
  label: "Händisch",
}

const automaticDeliveryOption: LetterDeliveryModeOption = {
  value: "automatic",
  label: "Automatisch",
}

const normalizedReason = (value: string | null | undefined): string | null => {
  const reason = String(value ?? "").trim()

  return reason ? reason : null
}

export const buildLetterDeliveryModeOptions = (
  options: LetterDeliveryModeAccessOptions = {},
): LetterDeliveryModeOption[] => {
  if (options.automaticLetterDeliveryAllowed !== false) {
    return [manualDeliveryOption, automaticDeliveryOption]
  }

  const disabledReason =
    normalizedReason(options.automaticLetterDeliveryDisabledReason) ??
    "Automatische Zustellung ist nicht verfügbar."

  return [
    manualDeliveryOption,
    {
      ...automaticDeliveryOption,
      disabled: true,
      selectable: false,
      tooltip: disabledReason,
      tooltipContent: disabledReason,
      description: disabledReason,
      dataTestid: "letter-delivery-mode.automatic.disabled",
    },
  ]
}
